<template>

    <div class="">

        <div class="flex flex-row justify-between items-start gap-x-8">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-medium flex items-center gap-x-2">AI Summary
                    <UpgradePlan v-if="!plan_transcribing" />
                </div>

                <div class="text-sm mt-3">Get an instant overview of your recordings - <docs-link
                        href="https://docs.birdie.so/birdie-docs/screen-recording/ai-summary" /></div>

            </div>

            <div class="flex flex-shrink">
                <toggle :checked="has_transcribing_enabled && plan_transcribing" @click.prevent.stop
                    :disabled="!plan_transcribing" @update="toggleConsole"></toggle>
            </div>
        </div>

    </div>

</template>






<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan.vue'


export default {

    props: ["transcribing_enabled", "plan_transcribing"],

    components: {
        Toggle,
        UpgradePlan
    },

    data() {
        return {
            has_transcribing_enabled: this.transcribing_enabled,
            saving: false,
        }
    },

    created() {
        // if (!this.is_guest) {
        //     if (this.$page.props.user.current_team.metadata) {
        //         let json = JSON.parse(this.$page.props.user.current_team.metadata)
        //         if (json.onboard_install) {
        //             this.onboard_install = json.onboard_install == "yes"
        //         }
        //     }
        // }
        //console.log(this.plan_live, this.plan_console)
    },
    computed: {
        // team_name() {
        //     return this.is_guest ? "" : this.$page.props.user.current_team.name
        // },
    },
    mounted() {

    },
    methods: {

        toggleConsole: function () {
            if (!this.plan_transcribing || this.saving) {
                return
            }
            this.has_transcribing_enabled = !this.has_transcribing_enabled
            this.updateMeta({
                meta: "transcribing_enabled",
                value: this.has_transcribing_enabled
            })
        },
        updateMeta: function (params) {
            if (!this.$page.props.canManageSettings) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        }
    }

}

</script>
